export { default as ProductsGrid } from "./ProductsGrid.styled";
